var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormationPlayer = _interopRequireDefault(require("./FormationPlayer"));

var _Basic = require("../../../elements/Basic");

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Formation/FormationRow.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FormationRow = function (_React$Component) {
  (0, _inherits2.default)(FormationRow, _React$Component);

  var _super = _createSuper(FormationRow);

  function FormationRow() {
    (0, _classCallCheck2.default)(this, FormationRow);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormationRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onPress = _this$props.onPress,
          away = _this$props.away,
          row = _this$props.row,
          createPlayerHref = _this$props.createPlayerHref,
          fieldWidth = _this$props.fieldWidth,
          isGoalKeeper = _this$props.isGoalKeeper,
          renderPlayer = _this$props.renderPlayer,
          NavWrapper = _this$props.NavWrapper,
          teamColor = _this$props.teamColor;
      if (!row) return null;
      return _react.default.createElement(_Basic.Row, {
        center: true,
        reverseRow: away,
        flexing: true,
        zIndex: 1,
        m: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 13
        }
      }, row.map(function (playerItem) {
        return typeof renderPlayer === 'function' ? renderPlayer(_objectSpread(_objectSpread({
          key: "renderPlayer_" + playerItem.lastName + "_" + playerItem.jerseyNumber,
          isGoalKeeper: isGoalKeeper,
          itemWidth: (0, _PropsHelper.getValueConditionally)(fieldWidth, fieldWidth / row.length),
          onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, playerItem),
          href: (0, _PropsHelper.executeFunctionOrUndefined)(createPlayerHref, playerItem),
          NavWrapper: NavWrapper
        }, teamColor), playerItem)) : _react.default.createElement(_FormationPlayer.default, {
          key: "formationPlayer_" + playerItem.lastName + "_" + playerItem.jerseyNumber,
          isGoalKeeper: isGoalKeeper,
          onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, playerItem),
          href: (0, _PropsHelper.executeFunctionOrUndefined)(createPlayerHref, playerItem),
          player: playerItem,
          itemWidth: (0, _PropsHelper.getValueConditionally)(fieldWidth, fieldWidth / row.length),
          NavWrapper: NavWrapper,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 50,
            columnNumber: 25
          }
        });
      }));
    }
  }]);
  return FormationRow;
}(_react.default.Component);

FormationRow.propTypes = {
  row: _propTypes.default.instanceOf(Array).isRequired,
  teamColor: _propTypes.default.object,
  onPress: _propTypes.default.func,
  away: _propTypes.default.bool,
  NavWrapper: _propTypes.default.func
};
var _default = FormationRow;
exports.default = _default;